import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
Hello World!
    </Text>
    <p>{`I'm Kevin Tan`}<br parentName="p"></br>{`
`}{`Yet another software developer @ Microsoft`}<br parentName="p"></br>{`
`}{`An amateur piano artist @ `}<a parentName="p" {...{
        "href": "https://music.163.com/#/artist/album?id=12459036"
      }}>{`Netease Music`}</a>{`     `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      